import { RotateCcw } from 'lucide-react';
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '@/components/ui/alert-dialog';
import { ActionButton } from './ActionButton';

interface RetryConfirmationDialogProps {
  onRetry: () => void;
  disabled: boolean;
  loading: boolean;
}

export const RetryConfirmationDialog: React.FC<
  RetryConfirmationDialogProps
> = ({ onRetry, disabled, loading }) => {
  return (
    <AlertDialog>
      <AlertDialogTrigger asChild>
        <ActionButton
          disabled={disabled}
          loading={loading}
          loadingText="Wird verarbeitet..."
          normalText="Erneut verarbeiten (Neue Abarbeitung von diesem Schritt starten)"
          icon={RotateCcw}
          className="bg-blue-500 hover:bg-blue-600 text-white shadow-sm"
        />
      </AlertDialogTrigger>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Neue Abarbeitung starten?</AlertDialogTitle>
          <AlertDialogDescription>
            Sie befinden sich auf einem früheren Abarbeitungsschritt. Durch die
            erneute Verarbeitung wird eine neue Abarbeitung ab diesem Schritt
            gestartet, was den aktuellen Prozessablauf beeinflussen kann.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Abbrechen</AlertDialogCancel>
          <AlertDialogAction
            onClick={onRetry}
            className="bg-blue-500 hover:bg-blue-600 text-white"
          >
            Erneut verarbeiten
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
